import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M4.08997 13.11C4.08997 13.11 7.38992 29.62 25.2299 23.68L23.9099 2.20999L1.44995 1.21997L4.08997 13.11Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M58.2499 13.11C58.2499 13.11 54.9499 29.62 37.1099 23.68L38.4299 2.20999L60.8899 1.21997L58.2499 13.11Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
